import { Link } from 'react-router-dom';
import { DISPLAY_LANG } from '../../../config';
import { noActiveServicesMessage } from '../../../api/user/dashboard';
import './ActiveServices.css';

export default function ActiveServices({ showActiveService, pageData, activeServicesCount }) {
    /**
     * @description_services_loop
     * im mot arandzin API ov stanum em servicener@,
     * ev arandzin API ov stanum em serviceneri qanakaner
     * tra hamar fracel em ays map@ vor miavor irar,
     * hamarjeq servicein ira count@
     * 
    */

    const services = pageData.services.map(service => {
        const found = Object.values(activeServicesCount)
            .find(item => item.type === service.type_for_count);

        return {
            ...service,
            count: found ? found.count : 0
        };
    });

    return (
        <div className='ActiveServices'>
            <h1 className='heading'>
                {
                    showActiveService ? (
                        pageData?.page_title
                    ) : (
                        noActiveServicesMessage[DISPLAY_LANG]
                    )
                }
            </h1>

            {showActiveService && <div className="active-services-list">
                {
                    services
                        .filter(elem => Number(elem.count))
                        .map(elem => (
                            <Link key={elem.id} to={elem.route} className='flex-between'>
                                {elem.label}
                                <span>{elem.count}</span>
                            </Link>
                        ))
                }
            </div>}
        </div>
    )
}
